import React, { useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import AgentHubService from 'services/AgentHubService';
import { AgentState } from './types';

const service = new AgentHubService();

/** Give an agent a specific task (POST /agent-hub/trigger); it runs on its next free slot. */
export default function TaskDialog({ agent, onClose, onSent }: { agent: AgentState | null; onClose: () => void; onSent: (msg: string) => void }) {
  const [task, setTask] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  if (!agent) return null;
  const send = () => {
    setBusy(true);
    service.trigger(agent.name, task)
      .then(() => { onSent(`Task sent to ${agent.name}: the hub has it, and it starts as soon as a slot is free.`); setTask(''); onClose(); })
      .catch(e => setError(e.message))
      .finally(() => setBusy(false));
  };
  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Give {agent.name} a task</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, pt: '8px !important' }}>
        {error && <Alert severity="error">{error}</Alert>}
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>{agent.description}</Typography>
        <TextField autoFocus multiline minRows={4} label="What should it do?" placeholder="e.g. Check that https://dosaze.com/products/… adds to cart and opens checkout" value={task} onChange={e => setTask(e.target.value)} />
        <Typography variant="caption" sx={{ color: 'text.secondary' }}>It runs on the next free slot, and its report appears on its page.</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={busy || task.trim().length < 5} onClick={send}>Send task</Button>
      </DialogActions>
    </Dialog>
  );
}
